import React, { useState } from "react";
import FloatingInput from "../../components/fields/FloatingInputText";
import useAuth from "../../hooks/useAuth";
import LoadingSpinner from "../../components/loading/LoadingSpinner";

interface AdminLoginProps {
  props?: any;
}

const AdminLogin = ({ props }: AdminLoginProps) => {
  const { login } = useAuth();
  interface LoginFormData {
    email: string;
    password: string;
  }

  const initialFormData: LoginFormData = {
    email: "",
    password: "",
  };

  interface LoginFormErrors {
    email: string;
    password: string;
  }

  const [formData, setFormData] = useState<LoginFormData>(initialFormData);

  const [formErrors, setFormErrors] = useState<LoginFormErrors>({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleChange = (e: HTMLInputElement) => {
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const regexEmail =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const validateForm = (data: LoginFormData) => {
    const errors: {
      email?: string;
      password?: string;
    } = {};
    if (!data.email) {
      errors.email = "Email is required";
    } else if (!regexEmail.test(data.email)) {
      errors.email = "Email is not a valid format";
    }
    if (!data.password) {
      errors.password = "Password is required";
    }
    return errors;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    let errors: any = validateForm(formData);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      try {
        setIsLoading(true);
        await login(formData.email, formData.password);
      } catch (err: any) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="flex items-center justify-center px-4 pt-12">
        <div className="card rounded-lg border border-neutral flex flex-col columns-1 items-center justify-center  gap-2 mb-4 w-full xs:w-11/12 sm:w-2/3 md:w-1/3 shadow-2xl">
          <div className="w-full bg-secondary flex items-center justify-center h-12 rounded-t-md">
            <div className={"italic font-extrabold text-2xl text-white "}>
              Admin Login
            </div>
          </div>
          <div className="w-2/3 py-2">
            <div className="mb-2">
              <FloatingInput
                name="email"
                label="Email"
                type="email"
                value={formData.email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e.target)
                }
                error={formErrors.email}
                inputProps={{ className: "w-full" }}
              />
            </div>
            <div className="mb-2">
              <FloatingInput
                name="password"
                label="Password"
                type="password"
                value={formData.password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(e.target)
                }
                error={formErrors.password}
                inputProps={{ className: "w-full" }}
              />
            </div>
            <div>
              <button
                className="btn btn-secondary btn-outline rounded-md  text-white font-bold text-lg py-2 px-4 w-full hover:text-white dark:hover:text-white"
                onClick={handleSubmit}
              >
                {isLoading ? (
                  <LoadingSpinner className="w-5 h-5" />
                ) : (
                  <span>Login</span>
                )}
              </button>
            </div>
          </div>
          <div className="flex items-center justify-center text-sm w-full"></div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
